import React from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'
import FnOCallPutV1 from './FnoCallPutV1'
import { getFetchRequest } from '@/root/utils/network-adapter/fetch-request'
import { indianStocksBackgroundApiBaseUrl } from '@/root/api/apiConstants'
import { ICategoryFnO } from '@/components/Stocks/FnO/types/options-chain'
import { FUTURES } from '@/components/Stocks/FnO/constants'
import InStockL2Heading from '@/components/Stocks/Pages/InStockDetailPageV2/InL2Heading'
import FnOListingWidgetV1 from '@/components/Stocks/FnO/ListingWidgetV1'

const FnO = ({
  isStocks = false,
  short_name,
  fnoApiData,
}: {
  isStocks?: boolean
  short_name?: string
  fnoApiData?: ICategoryFnO | null
}) => {
  const router = useRouter()
  const slug = router.query.stockSlug as string

  const {
    data,
  }: {
    data?: ICategoryFnO
  } = useQuery(
    ['fnoCategories', slug],
    () =>
      getFetchRequest({
        url: `${indianStocksBackgroundApiBaseUrl}/fno/catalog/categories/${slug}`,
      }),
    {
      retry: 1,
      initialData: fnoApiData ?? {},
    },
  )

  const categoryData =
    data?.catalog?.stock_details ?? data?.catalog?.index_details

  const futures = categoryData?.categories?.find(item =>
    item.category_code.toUpperCase().includes(FUTURES),
  )

  const hasFNO = categoryData?.categories?.some(
    category => category.stocks?.length,
  )

  if (!hasFNO && !futures?.stocks?.length) {
    return null
  }

  return (
    <div>
      <InStockL2Heading
        heading={`${
          short_name ? `${short_name} Stock` : ''
        } Futures & Options Contracts`}
        subheading={`View the latest movement in ${
          short_name ?? ''
        } Futures & Options, including strike prices, expiry dates, and percentage changes.
`}
      />
      <div className="flex flex-col gap-y-11">
        {categoryData && (
          <FnOCallPutV1
            isStocks={isStocks}
            short_name={short_name}
            categoryData={categoryData}
          />
        )}

        {!!futures?.stocks?.length && (
          <FnOListingWidgetV1
            categoryData={futures.stocks}
            heading={isStocks ? `${short_name} Futures` : 'Futures'}
          />
        )}
      </div>
    </div>
  )
}

export default React.memo(FnO)
